module.exports = __webpack_public_path__ + "5c114213/img/send-icon.3cfb6275.svg";